// User utility functions for managing user data locally
import { getUser } from './secureStorage';

/**
 * Set the user's first name in localStorage
 * @param {string} firstName - The user's first name
 */
export const setUserFirstName = (firstName) => {
  if (firstName) {
    localStorage.setItem('userFirstName', firstName);
  }
};

/**
 * Get the user's first name from localStorage
 * @returns {string} The user's first name or 'there' as default
 */
export const getUserFirstName = () => {
  // First try to get from the secure user object
  const user = getUser();
  if (user && user.first_name) {
    return user.first_name;
  }

  // Fallback to the separate userFirstName key
  const fallbackName = localStorage.getItem('userFirstName') || 'there';
  return fallbackName;
};

/**
 * Get a dynamic greeting based on current time
 * @returns {string} The appropriate greeting (morning, afternoon, evening, night)
 */
export const getTimeOfDay = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "morning";
  if (hour < 17) return "afternoon";
  if (hour < 21) return "evening";
  return "night";
};

/**
 * Get a complete greeting with user's name and time of day
 * @returns {string} Complete greeting string
 */
export const getGreeting = () => {
  const timeOfDay = getTimeOfDay();
  const userName = getUserFirstName();
  return `Good ${timeOfDay.charAt(0).toUpperCase() + timeOfDay.slice(1)}, ${userName}! 👋`;
};

/**
 * Clear user data from localStorage (useful for logout)
 */
export const clearUserData = () => {
  localStorage.removeItem('userFirstName');
}; 